import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames';
import BreadcrumbsItem from './BreadcrumbsItem'

/**
 * Display a series of breadcrumbs to indicate the user's location within the
 * app. Note: This is just the container, the actual breadcrumb items are
 * provided as child components.
 */
export default function Breadcrumbs({ children, className }) {
  const classes = cn('c-breadcrumbs', className);
  return (
    <nav className={classes} aria-label="Breadcrumb">
      <ol className="c-breadcrumbs__list">
        {children}
      </ol>
    </nav>
  )
}

/**
 * Attach the breadcrumb item components to the breadcrumbs component for
 * convenience.
 */
Breadcrumbs.Item = BreadcrumbsItem

Breadcrumbs.propTypes = {
  children: PropTypes.node.isRequired,
  classname: PropTypes.string,
}
